<template>
    <div class="socialevents">
        <div class="section-header">
            <p class="section-kicker">Photo Archive</p>
            <h2 class="card-title">Gallery highlights</h2>
            <p class="section-copy">
                Explore our collection of photos, videos, and event highlights showcasing life at Lagos Lawn Tennis Club.
            </p>
        </div>

        <div class="cards">
            <div class="card-item" v-for="(card, index) in dataList" :key="index">
                <GalleryCard
                    :title="card.title"
                    :content="card.description.length > 100 ? card.description.substring(0, 100) + '...' : card.description"
                    :image="card.image"
                    :date="card.date"
                    @click="openImagePopup(card.image)"
                />
            </div>
        </div>
    </div>

    <!-- IMAGE POPUP -->
    <div v-if="showPopup" class="popup-overlay" @click="closePopup">
        <div class="popup-content" @click.stop>
            <img :src="popupImage" alt="Preview Image" />
            <button class="close-btn" @click="closePopup">×</button>
        </div>
    </div>
</template>

<script setup>
import GalleryCard from "./CommonCard/GalleryCard.vue";
import axios from "axios";
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

let base_url = process.env.VUE_APP_BASE_LIVE_URL;
const dataList = ref([]);
const showPopup = ref(false);
const popupImage = ref("");

watch(
  () => route.query.archive,
  () => {
    listGallery();
  }
);

onMounted(async () => {
  await listGallery();
});

onBeforeUnmount(async () => {
  
});

const openImagePopup = (img) => {
  popupImage.value = img;
  showPopup.value = true;
};

const closePopup = () => {
  showPopup.value = false;
};

const listGallery = async () => {
  try {
    const archive = route.query.archive;

    const response = await axios.get("/photo_gallery_list_all.php", {
      params: archive ? { archive } : {}
    });

    dataList.value = response.data.data.map((data) => ({
      title: data.title,
      description: data.description,
      date: data.date,
      image: `${base_url}/${data.banner_image}`
    }));
  } catch (error) {
    console.error(error.message);
  }
};
</script>

<style scoped lang="scss">
.socialevents {
    width: 100%;
    margin: 0;
}

.section-header {
    margin-bottom: 22px;
}

.section-kicker {
    margin: 0 0 8px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-copy {
    margin: 10px 0 0;
    max-width: 760px;
    color: #64748b;
    font-size: 16px;
    line-height: 1.7;
}

.buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    overflow-x: auto;
}

.cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;
    cursor: pointer;
}

.card-item {
    min-width: 0;
}

.card-title {
    font-size: clamp(30px, 3vw, 48px);
    font-weight: 700;
    margin: 0;
}

@media (max-width: 992px) {
    .cards {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .socialevents {
        margin-top: 0;
    }

    .cards {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .card-title {
        font-size: 30px;
    }
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: hidden;
}

.popup-content {
  position: relative;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  background: transparent;
  border-radius: 10px;
}

.popup-content img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
}

.close-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 24px;
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.3);
  z-index: 10000;
}
</style>
